import { render, staticRenderFns } from "./customerStatistics.vue?vue&type=template&id=107c9cde&"
import script from "./customerStatistics.vue?vue&type=script&lang=js&"
export * from "./customerStatistics.vue?vue&type=script&lang=js&"
import style0 from "./customerStatistics.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports